import { Injectable } from '@angular/core';
import { SalesTeamInterface, SalesTeamsServiceInterface } from '@vendasta/sales-common';
import { BehaviorSubject, forkJoin, Observable, SchedulerLike } from 'rxjs';
import { take } from 'rxjs/operators';
import { AjaxSalesTeamsService } from '../sales-teams/ajax-sales-teams.service';

@Injectable({
  providedIn: 'root',
})
export class SalesTeamsService implements SalesTeamsServiceInterface {
  private readonly arrayOfSalesTeamMembers$$: BehaviorSubject<string[][]> = new BehaviorSubject(null);
  public arrayOfSalesTeamMembers$: Observable<string[][]> = this.arrayOfSalesTeamMembers$$.asObservable();

  constructor(private readonly ajaxSalesTeamsService: AjaxSalesTeamsService) {}

  getSalesTeams$(partnerId: string, marketId: string, _scheduler?: SchedulerLike): Observable<SalesTeamInterface[]> {
    return this.ajaxSalesTeamsService.list(marketId);
  }

  listSalesTeamMembers(groupId: string): Observable<string[]> {
    return this.ajaxSalesTeamsService.getMembers(groupId);
  }

  salesTeamIdsToArrayOfSalesPeopleIds(salesTeamIds: string[]): void {
    if (salesTeamIds.length === 0) {
      return this.arrayOfSalesTeamMembers$$.next([]);
    }
    const arrayOfSalesTeams: Observable<string[]>[] = [];
    salesTeamIds.map((salesTeamId) => {
      arrayOfSalesTeams.push(this.listSalesTeamMembers(salesTeamId).pipe(take(1)));
    });
    forkJoin(arrayOfSalesTeams)
      .pipe(take(1))
      .subscribe((array) => {
        this.arrayOfSalesTeamMembers$$.next(array);
      });
  }
}
